import React, { useMemo, useState } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { useAssessment } from './hooks/useAssessment';
import { EmailGate } from './pages/EmailGate';
import { Intro } from './pages/Intro';
import { Loading } from './pages/Loading';
import { Questions } from './pages/Questions';
import { Results } from './pages/Results';
import type { ArchetypeResult } from './types/assessment';
import { subscribeToMailchimp } from './utils/mailchimp';
import { buildProfile } from './utils/scoring';
export function App() {
  const assessment = useAssessment();
  const [profile, setProfile] = useState<ArchetypeResult[] | null>(null);
  const previewProfile = useMemo(() => buildProfile(assessment.answers), [assessment.answers]);
  const handleEmailSubmit = async (email: string) => {
    const computed = previewProfile;
    assessment.setStep('loading');

    // Fire-and-forget: a Mailchimp failure must never withhold someone's results.
    void subscribeToMailchimp({
      email,
      primary: computed[0].key,
      secondary: computed[1].key
    });
    window.setTimeout(() => {
      setProfile(computed);
      assessment.clearProgress();
      assessment.setStep('results');
    }, 900);
  };
  return <div className="min-h-full w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3rdki07xp0nov">
      <SiteHeader data-id="element-1" data-mp="6hqtghuuhen" />
      <main data-id="element-2" data-mp="4wvhonpuufq">
        {assessment.step === 'intro' && <Intro hasSavedProgress={assessment.hasSavedProgress} onStart={() => assessment.start()} onRestart={() => assessment.start({
        fresh: true
      })} data-id="element-3" data-mp="2zl39tfhhuw2o" />}

        {assessment.step === 'questions' && <Questions page={assessment.page} totalPages={assessment.totalPages} totalQuestions={assessment.totalQuestions} pageQuestions={assessment.pageQuestions} answers={assessment.answers} answeredCount={assessment.answeredCount} validationMessage={assessment.validationMessage} onAnswer={assessment.answerQuestion} onNext={assessment.goNext} onBack={assessment.goBack} data-id="element-4" data-mp="38l017ov9q91f" />}

        {assessment.step === 'email' && <EmailGate onSubmit={handleEmailSubmit} onBack={assessment.backToQuestions} data-id="element-5" data-mp="d4e94339pv1g" />}

        {assessment.step === 'loading' && <Loading data-id="element-6" data-mp="86w6eufugc1w" />}

        {assessment.step === 'results' && profile && <Results profile={profile} data-id="element-7" data-mp="3gl4pnbwh7qhe" />}
      </main>
    </div>;
}